import { useState } from "react";
import { Typography } from "@mui/material";
import Dialog from "../Common/Dailog/Dailog";
import FullScreenLoader from "../Common/ScreenLoader/FullScreenLoader";
import customConfig from "../../config";
import { deleteInAppNotification, getInAppNotificationErrorMessage } from "../../action/inAppNotification";

const DeleteNotificationDialog = ({
  open,
  notification,
  onClose,
  feedbackHandler,
}) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!notification?.id) return;

    setLoading(true);
    try {
      await deleteInAppNotification(notification.id);
      feedbackHandler({
        open: true,
        type: "success",
        msg: customConfig.DELETE_SUCCESS,
      });
      onClose({ success: true });
    } catch (error) {
      feedbackHandler({
        open: true,
        type: "error",
        msg: getInAppNotificationErrorMessage(error, customConfig.DELETE_FAILURE),
      });
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      title="Delete Notification"
      maxWidth="xs"
      fullWidth
      showCloseButton
      actions={[
        { label: "Cancel", variant: "ghost", onClick: () => onClose() },
        {
          label: "Delete",
          variant: "primary",
          onClick: handleDelete,
          disabled: loading,
        },
      ]}
    >
      {loading && <FullScreenLoader message={customConfig.DELETING_DATA} />}
      <Typography variant="body2">
        Are you sure you want to delete this notification?
      </Typography>
    </Dialog>
  );
};

export default DeleteNotificationDialog;
